import './Landing.css';
import Navbar from '../components/Navbar';
import Hero from '../components/Landing/Hero';
import HowItWorks from '../components/Landing/HowItWorks';
import WhoItsFor from '../components/Landing/WhoItsFor';
import Pricing from '../components/Landing/Pricing';
import Faq from '../components/Landing/Faq';
import Footer from '../components/Footer';

function Landing() {
    return (
        <div className="al-page">
            <div className="al-page-top">
                <div className="al-dev-banner" role="status">
                    <p>
                        <span aria-hidden="true">🚧</span>
                        {' '}Numus is still under development — details & features may be incomplete or subject to changes.{' '}
                        <span aria-hidden="true">🚧</span>
                    </p>
                </div>
                <Navbar />
            </div>

            <main>
                <Hero />
                <HowItWorks />
                <WhoItsFor />
                <Pricing />
                <Faq />
            </main>

            <Footer />
        </div>
    );
}

export default Landing;
